import React from 'react';

const AllianceProfile = () => {
  return <h1>AllianceProfile Page</h1>;
};

export default AllianceProfile;
